import React from 'react';
import { Sparkle, Squiggle } from './PotatoSVG';
import { scrollHint } from '../mock';
import { getSite } from '../siteConfig';
import { ArrowDown } from 'lucide-react';
import InteractivePotato from './InteractivePotato';

const Hero = () => {
  const kicker = getSite('hero_kicker', 'ideas so good,');
  const headingBefore = getSite('hero_heading_before', 'they should be');
  const headingHighlight = getSite('hero_heading_highlight', 'illegal');
  const headingAfter = getSite('hero_heading_after', '.');
  const sub = getSite('hero_subtext', '(They’re not. We checked.)');
  const scroll = getSite('hero_scroll', 'scroll to explore');
  return (
    <section className="relative overflow-hidden bg-[#FFFCF5] pt-6 pb-4">
      <div className="relative mx-3 sm:mx-4 md:mx-6 rounded-[24px] md:rounded-[32px] overflow-hidden bg-[#FFD200] border-2 border-black grain">
        <div className="absolute inset-0 opacity-[0.08] pointer-events-none" style={{backgroundImage:'linear-gradient(#111 1px, transparent 1px), linear-gradient(90deg, #111 1px, transparent 1px)',backgroundSize:'48px 48px'}} />
        <Sparkle className="absolute top-6 left-6 md:top-10 md:left-10 w-6 h-6 md:w-8 md:h-8 float-slow" color="#fff" />
        <Sparkle className="absolute top-16 right-8 md:top-24 md:right-16 w-4 h-4 md:w-6 md:h-6 float-fast" color="#111" />
        <Sparkle className="absolute bottom-24 left-1/4 w-4 h-4 md:w-5 md:h-5 float-slow" color="#FF6B6B" />
        <div className="relative z-10 grid lg:grid-cols-[1.15fr_1fr] gap-6 lg:gap-4 items-center px-5 sm:px-8 md:px-12 lg:px-16 pt-14 md:pt-20 lg:pt-24 pb-20 md:pb-24 min-h-[540px] md:min-h-[620px] lg:min-h-[660px]">
          <div>
            <p className="font-hand text-2xl sm:text-3xl md:text-4xl lg:text-5xl -rotate-3 inline-block">{kicker}</p>
            <h1 className="font-display font-extrabold leading-[0.9] lowercase mt-2 tracking-tight text-[40px] sm:text-[64px] md:text-[92px] lg:text-[110px] xl:text-[128px]">
              {headingBefore} <span className="yellow-brush !bg-black/25">{headingHighlight}</span>{headingAfter}
            </h1>
            <div className="mt-4 md:mt-6 max-w-md">
              <Squiggle className="w-32 md:w-40 h-3 md:h-4 mb-3" />
              <p className="font-body text-sm sm:text-base md:text-lg text-black/80 leading-relaxed">{sub}</p>
            </div>
          </div>
          <div className="relative flex items-center justify-center mt-6 lg:mt-0"><InteractivePotato /></div>
        </div>
        <div className="absolute bottom-4 md:bottom-6 left-0 right-0 flex items-center justify-center px-5 sm:px-8 md:px-16 pointer-events-none">
          <div className="flex items-center gap-2 text-xs md:text-sm font-medium"><ArrowDown size={16} className="animate-bounce" /><span>{scroll}</span></div>
        </div>
      </div>
      <div className="mt-8 md:mt-10 overflow-hidden py-3">
        <div className="marquee-track marquee-track-slow font-quote text-4xl sm:text-5xl md:text-7xl text-black/85 whitespace-nowrap tracking-normal">
          {['1','2','3','4'].map(id => <span key={id} className="px-10 md:px-14">“{scrollHint}”</span>)}
        </div>
      </div>
    </section>
  );
};
export default Hero;
